import React, {useState} from "react";
import './sdDropdown.scss';

function SDDropdown (props) {
    const [check, setCheck] = useState(false);
    let options = props.data ?? [];

    return (
        <div className="mainDd" onClick={() => {setCheck(!check)}}>
            <div className="nowSelect">
                <div>{props.value ? props.value : props.placeholder}</div>
                <div className="drop"></div>
            </div>
            <div className={`dropData ${check ? '' : 'hideData'}`}>
                {options.map(d => {
                    return <div className="selection" key={d.key}>{d.value}</div>
                })}
            </div> 
            {check ? <div className="mask"  onClick={() => {setCheck(!check)}}></div> : ''}
        </div>
    )
}

export default SDDropdown;